import { render, staticRenderFns } from "./auth-redirecting.vue?vue&type=template&id=2b3964d2&"
import script from "./auth-redirecting.vue?vue&type=script&lang=js&"
export * from "./auth-redirecting.vue?vue&type=script&lang=js&"
import style0 from "./auth-redirecting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports